import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    CriteriaMutationResourceSchema,
    type CriteriaResource,
    defaultCriteriaResource,
    useCriteriaActions,
} from '../../../../../resource/resources/artifacts/criteria/criteriaResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { CriteriaContent } from './CriteriaContent';

export const CriteriaCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: CriteriaResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const criteriaActions = useCriteriaActions();
    const addCriteria = criteriaActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: CriteriaMutationResourceSchema,
        defaultValues: {
            ...defaultCriteriaResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addCriteria.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Criteria'}
            resourceType={ResourceType.CRITERIA}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <CriteriaContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
